/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import {
    useDnsRecordsQuery,
    useDomainContactsQuery,
    useDomainRenewalQuery,
    useEligibilityDetailsQuery,
    useEppCodeQuery
} from 'api/domain'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    children: ReactNode
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Domain({ children }: Props) {
    const location = useLocation()
    const id = +location.pathname?.split('/')[2]
    useDnsRecordsQuery(id, { skip: !id })
    useEppCodeQuery(id, { skip: !id })
    useEligibilityDetailsQuery(id, { skip: !id })
    useDomainRenewalQuery(id, { skip: !id })
    useDomainContactsQuery(id, { skip: !id })

    return (
        <>
            {children}
        </>
    )
}
